module.exports = __webpack_public_path__ + "assets/8b02aa1d46f37c2db0d92795ecf798c9.svg";